import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LastWillDetailsStep(): ReactElement {
  const dispatch = useDispatch();
  const { willReflectsCurrentWishes: willReflectsCurrentWishes } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('current_will_wishes');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader
        header="Does your will reflect your current wishes?"
        subHeader=" For example, does your will state who you currently want to inherit your
          assets or take care of you dependents (if applicable)?"
      />
      <Formik
        initialValues={{ willReflectsCurrentWishes }}
        onSubmit={onSubmit}
        validationSchema={createYesNoObjectSchema('willReflectsCurrentWishes')}
      >
        <Form ref={formRef}>
          <YesOrNoStepCreator
            name="willReflectsCurrentWishes"
            showNotSure={true}
          />

          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { LastWillDetailsStep };
